/* tslint:disable */

/**
 */
export class CheckAdmin {
    checkit?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/check-admin.ts